export enum ECellType {
  CELL = "cell",
  HEADER = "header",
}
